
export default {  
    methods: {
				isCordovaWrapperVersionLowerThan(version) {
					var result = this.compareCordovaWrapperVersion(version);
					return result == -1;
				},
				compareCordovaWrapperVersion(b) {
						var a = window.$store.state.wedrive.cordovaWrapperVersion;
						
						if (!a) {
							return 0;
						}

						var pa = a.split('.');
						var pb = b.split('.');

						for (var i = 0; i < 3; i++) {
								var na = Number(pa[i]);
								var nb = Number(pb[i]);
								if (na > nb) return 1;
								if (nb > na) return -1;
								if (!isNaN(na) && isNaN(nb)) return 1;
								if (isNaN(na) && !isNaN(nb)) return -1;
						}

						return 0;
				}
		}
}